export default __webpack_public_path__ + "46c8060c67c4f1ff36a57641e90c011d.svg";